import {z} from 'zod';

import {getTodayAt0Hours} from '../../utils/date';

const REQUIRED_FIELD_MESSAGE = 'This is a required field';

// Australian phone: +61/61/0 + area code [2,4,7,8] + 8 digits
const AUSTRALIAN_PHONE_REGEX = /^(\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;

const oneYearFromNow = new Date();
oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

export const giftCardDataSchema = z.object({
  recipientName: z.string().min(1, REQUIRED_FIELD_MESSAGE),
  note: z.string().min(1, REQUIRED_FIELD_MESSAGE).max(500, 'Message cannot exceed 500 characters'),
  recipientEmail: z
    .string()
    .min(1, REQUIRED_FIELD_MESSAGE)
    .email('Please enter a valid email address'),
  recipientPhoneNumber: z
    .string()
    .min(1, REQUIRED_FIELD_MESSAGE)
    .regex(AUSTRALIAN_PHONE_REGEX, 'Please enter a valid Australian phone number'),
  deliveryDate: z
    .date({required_error: REQUIRED_FIELD_MESSAGE, invalid_type_error: 'Please enter a valid date'})
    .min(getTodayAt0Hours(), 'Delivery date cannot be in the past')
    .max(oneYearFromNow, 'Delivery date cannot be more than one year from now'),
});

export type GiftCardFormData = z.infer<typeof giftCardDataSchema>;
